import React from 'react'
import LoginForm from "../../Components/LoginForm";
import classes from './style.module.css'

export default function LoginPage() {

    function setLoginBG(val) {
        switch (val) {
            case "wl":
                return classes.WLLoginBG
            case "unlimco":
                return classes.UnlimcoLoginBG
            case "eclear":
                return classes.EclearLoginBG
            default:
                return classes.WLLoginBG
        }
    }

    return (
        <div className={`${classes.LoginPage} ${setLoginBG(process.env.BRAND)}`}>
            <div className={classes.Container}>
                <div className={classes.LoginWrap}>
                    <LoginForm />
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/PagesOfCommon/Login/index.js